import React from 'react'
import { Box, CircularProgress } from '@mui/material'

// ครอบเนื้อหา แล้วซ้อน overlay จาง + spinner ระหว่าง refetch (ยังเห็นข้อมูลเก่าใต้ overlay)
export default function LoadingOverlay({ loading, children }) {
    return (
        <Box sx={{ position: 'relative' }}>
            {children}
            {loading && (
                <Box sx={{
                    position: 'absolute', inset: 0, zIndex: 3,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(255,255,255,0.55)', borderRadius: '10px',
                    transition: 'opacity 0.15s',
                }}>
                    <CircularProgress size={44} />
                </Box>
            )}
        </Box>
    )
}
